
<template>
  <div>
    <chc-modal ref="paymentDetailsModal" title="Payment Details">
      <div slot="body">
        <payment-details :charityId="charityId"
                      :paymentId="paymentId"
                          v-on:close="paymentDetailsHide">
        </payment-details>
      </div>
    </chc-modal>
  <div class="proceeds-container tabbed-content">
    <datatable
      :source="proceeds"
      :filterable="false"
      :isLoading="isLoading"
      :message="tableMessage">
      <datatable-column
        v-for="(column, index) in columns"
        :id="column.id"
        :label="column.label"
        :key="index"
        :sortKey="column.sort">
      </datatable-column>

      <template slot="searchLeft">
        <div class="field">
          <multiselect
            placeholder="Years"
            v-model="years"
            :options="yearOptions"
            :multiple="true"
            :allow-empty="false"
            :hide-selected="false"
            :close-on-select="false"
            @open="() => {yearsOpened = true}"
            @remove="() => {if (!yearsOpened) {
              $nextTick(() => {
                refresh()
              })
            }}"
            @close="() => {
              yearsOpened = false
              refresh()
            }"
          ></multiselect>
        </div>
      </template>

      <template slot="source_template" slot-scope="data">
        <tr>
          <td>{{ data.row.date }}</td>
          <td>{{ data.row.check_number }}</td>
          <td>{{ data.row.vehicle_count }}</td>
          <td>{{ data.row.amount_paid }}</td>
          <td><a @click="viewDetails(data.row.id)">View Details</a></td>
        </tr>
      </template>

      <template slot="tfoot" slot-scope="data">
        <tr>
          <td>TOTAL</td>
          <td></td>
          <td>{{ total }}</td>
          <td>{{ total_paid }}</td>
          <td></td>
        </tr>
      </template>
    </datatable>
  </div>
  </div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import store from '@/store'
import PaymentDetails from '@/components/Payables/PaymentDetails'

import Multiselect from 'vue-multiselect'

export default {
  name: 'CharityProceeds',
  props: ['charityId'],
  mounted () {
    Promise.all([
      store.functions.charity.getVehicleYears(this.charityId, (response) => { this.yearOptions = response.data }),
      store.functions.charity.getProceeds(this.charityId, (response) => {
        this.proceeds = response.data.table_data
        this.total_paid = response.data.total_paid
        this.total = response.data.total
      }, JSON.stringify(this.years))
    ]).then(response => {
      // pass
    }).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    let now = new Date()
    return {
      columns: [
        { id: 'date', label: 'Date Paid', sort: 'date_sort' },
        { id: 'check_number', label: 'Check #' },
        { id: 'vehicle_count', label: 'Vehicle Count' },
        { id: 'amount_paid', label: 'Amount Paid' },
        { id: 'view', label: 'View Details' }
      ],
      isLoading: true,
      proceeds: [],
      total_paid: 0,
      total: 0,
      tableMessage: null,

      paymentId: null,

      yearsOpened: false,
      years: [now.getFullYear()],
      yearOptions: [now.getFullYear()],
    }
  },
  components: {
    Datatable,
    DatatableColumn,
    PaymentDetails,
    Multiselect
  },
  methods: {
    refresh () {
      if (this.isLoading) return
      this.isLoading = true
      store.functions.charity.getProceeds(this.charityId, (response) => {
        this.proceeds = response.data.table_data
        this.total_paid = response.data.total_paid
        this.total = response.data.total
        this.isLoading = false
      }, JSON.stringify(this.years)).catch(err => {
        console.log(err)
        this.proceeds = []
        this.total_paid = null
        this.total = null
        this.tableMessage = 'Request to large to load, please reduce the number of years selected'
      })
    },
    viewDetails (id) {
      this.paymentId = id
      this.$refs.paymentDetailsModal.show()
    },
    paymentDetailsHide () {
      this.$refs.paymentDetailsModal.hide()
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
.field {
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Charity/CharityProceeds.vue